import React, { Component } from "react"
import "./InfoBoxes.scss"
import BuyButton from "../Helpers/Buttons/BuyButton"
import _Remote from "../../api/Remote.json"

class InfoBoxes extends Component {
    constructor(props) {
        super();
        this.toggleBox = this.toggleBox.bind(this);
        this.state = {
            isActive: false
        }
    }
    toggleBox() {
        this.setState({
            isActive: !this.state.isActive
        })
    }
    doBoxes() {
        return _Remote.map((item, index) =>
            <div key={index} className={`box ${index == this.props.current ? " active" : ""} ${item.className}`} style={item.CSS}>
                <div className="over-padding">
                    <div className="text" dangerouslySetInnerHTML={{ __html: item.HTML }}></div>
                    {item.purchaseLink ? <BuyButton sectionName="רכיב שלט" buttonText={"לחץ להזמנה"} onClick={() => window.open(item.purchaseLink, "_blank")} /> : ""}
                </div>
            </div>
        )
    }
    render() {
        return (
            <div className="boxes">
                {this.doBoxes()}
            </div>
        )
    }
}

export default InfoBoxes;


// WEBPACK FOOTER //
// ./src/Components/Remote/InfoBoxes.jsx